import React from 'react'
import { Metadata } from 'next';

export const metadata: Metadata = {
  title: 'Loading... | TEX EXCELLENCE LIMITED',
  description: 'Loading... | TEX EXCELLENCE LIMITED',
}

const loading = () => {
    return (
        <div>
            <div className="preloader">
                <div className="loader-ripple">
                    <div />
                    <div />
                </div>
            </div>
        </div>
    )
}

export default loading
